import { InjectionToken } from '@angular/core';
import { CoreConfig } from '../shared/models/index';

export const coreConfig = new InjectionToken<CoreConfig>('coreConfig');
